import { useParams } from "react-router-dom";
import SubmissionStatusMain from "./components/submissionStatusMain/submissionStatusMain";

const SubmissionStatus = () => {
  const { id } = useParams();
  return (
    <div className="submission-info__main-container flex h-full w-full flex-col justify-center gap-4 overflow-hidden bg-lightGray px-3.5 pb-2.5 pt-4">
      <div className="submission-info__body flex-1 overflow-hidden bg-white">
        <SubmissionStatusMain id={id ?? ""} />
      </div>
    </div>
  );
};

export default SubmissionStatus;
